import { ChangeEvent, FC, useEffect, useMemo } from 'react'

import { FormSelect } from '@/components'
import { ShiftViewModel } from '@/models'
import { SettingResource } from '@/models/Setting'

import { getShiftSelectOptions } from './helpers/getShiftSelectOptions'


interface FormUserSelectProps {
    shifts: ShiftViewModel[]
    userId?: string
    settings: SettingResource[]
    selectedShift: string | null
    onSelectShift: (shift: ShiftViewModel) => void
}

export const FormShiftSelect: FC<FormUserSelectProps> = ({
    selectedShift,
    shifts,
    settings,
    userId,
    ...props
}) => {
    const options = useMemo(() => getShiftSelectOptions(shifts, userId, settings), [shifts])

    useEffect(() => {
        if (shifts.length) {
            props.onSelectShift((shifts[0]))
        }
    }, [shifts])

    const onSelectShift = (event: ChangeEvent<HTMLSelectElement>) => {
        const value = shifts.find(shift => shift.id === event.target.value)

        if (value) {
            props.onSelectShift(value)
        }
    }

    return (
        <FormSelect
            options={options}
            selected={selectedShift}
            onChange={onSelectShift}
        />
    )
}
